module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-227.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.2.1.md
// module id = 670
// module chunks = 329